import React, { useCallback } from 'react';
import styled from '@emotion/styled';
import AuraLogo from '@trinity/chat-components/static/images/aura-icon.svg?url';

type SegmentAvatarProps = {
  iconUrl: string;
  name: string;
  onChatWithSegment: () => void;
  primaryColor?: string;
  whitelabelEnabled?: boolean;
};

type AvatarRingProps = {
  borderColor: string;
};

const AvatarContainer = styled.div`
  position: relative;
  flex-shrink: 0;
  margin-left: 16px;
  margin-right: 24px;
  margin-bottom: 16px;
`;

const AvatarRing = styled.div<AvatarRingProps>`
  width: 122px;
  height: 122px;
  border-radius: 50%;
  border: 3px solid ${props => props.borderColor};
  padding: 3px;
  background: white;
  box-sizing: border-box;
`;

const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  display: block;
`;

type ChatButtonProps = {
  accentColor: string;
};

const ChatButton = styled.button<ChatButtonProps>`
  position: absolute;
  bottom: -16px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: ${props => props.accentColor};
  color: white;
  border: none;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.85;
  }

  &:focus-visible {
    outline: 2px solid ${props => props.accentColor};
    outline-offset: 2px;
  }

  img {
    width: 14px;
    height: 14px;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));
  }
`;

export function SegmentAvatar({
  iconUrl,
  name,
  onChatWithSegment,
  primaryColor,
  whitelabelEnabled,
}: SegmentAvatarProps): React.ReactElement {
  const accentColor = whitelabelEnabled && primaryColor ? primaryColor : '#28aae1';

  const handleClick = useCallback(() => {
    onChatWithSegment();
  }, [onChatWithSegment]);

  return (
    <AvatarContainer>
      <AvatarRing borderColor={accentColor}>
        <AvatarImage
          src={iconUrl}
          alt={`${name} avatar`}
        />
      </AvatarRing>
      <ChatButton
        accentColor={accentColor}
        onClick={handleClick}
        aria-label={`Chat with ${name}`}>
        <img src={AuraLogo} alt="" aria-hidden="true" />
        Chat with Segment
      </ChatButton>
    </AvatarContainer>
  );
}
